import { useGanttContext } from "../gantt.context";
import { GanttGroupRowView } from "./view-group-row";
import { GanttRowView } from "./view-row";

/** Corpo: as linhas visíveis na ordem do ViewModel, com o cabeçalho de cada grupo antes das suas linhas. */
export function GanttBodyView() {
  const { body } = useGanttContext();

  return body.map((item) =>
    item.type === "group" ? (
      <GanttGroupRowView key={`group-${item.key}`} group={item} />
    ) : (
      <GanttRowView key={item.key} row={item} />
    ),
  );
}
GanttBodyView.displayName = "Gantt.Body";
